import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

// Cargar mensajes de forma modular
const messages = {
  en: require("./locales/en.json"),
  es: require("./locales/es.json"),
  pt: require("./locales/pt.json"),
  fr: require("./locales/fr.json")
};

// Detectar idioma del navegador o usar 'es' como predeterminado
const browserLang = navigator.language.split("-")[0];
const defaultLang = Object.keys(messages).includes(browserLang)
  ? browserLang
  : "es";

// Cargar idioma guardado si existe
const savedLang = localStorage.getItem("userLanguage");
const initialLocale = savedLang || defaultLang;

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: "en",
  silentTranslationWarn: process.env.NODE_ENV === "production",
  messages
});

export default i18n;
